import React from 'react';
import styles from './Checkbox.module.css';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, label, onClick, disabled, className }) => {
  return (
    <label className={`${styles.checkboxWrapper} ${className || ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onClick={onClick}
        onChange={e =>{ onChange(e.target.checked)}}
        disabled={disabled}
        className={styles.checkboxInput}
      />
      <span className={styles.customCheckbox} />
      {label && <span className={styles.checkboxLabel}>{label}</span>}
    </label>
  );
};

export default Checkbox;
